import React from "react";
import { useTranslation } from "react-i18next";

import * as styles from "./chat-sidebar-header.css";

interface ChatSidebarHeaderProps {
  title?: string;
}

export const ChatSidebarHeader: React.FC<ChatSidebarHeaderProps> = ({
  title
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.header} data-testid="chat-sidebar-header">
      <h1 className={styles.title}>{title || t("chat.title", "Chats")}</h1>
    </div>
  );
};
